import type {Book, Chapter, TableOfContent} from '../flow/book'
import offlineHandler from './fs'

const baseUrl: string = process.env.VUE_APP_BOOKSYNC_URL + '/api' || ''
const streamerBaseUrl: string = process.env.VUE_APP_DPM_URL || ''

export default {
  getBook: async function (accessToken: string, bookId: string): Promise<Book> {
    let data
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }

    try {
      data = await (await fetch(baseUrl + '/pubs/' + bookId, options)).json()
    } catch (err) {
      // assume offline
      data = await offlineHandler.getBook(bookId).catch((err) => {
        // TODO: remove alert
        alert('This books is not saved locally. Please download it first')
      })
    }

    return data
  },

  fetchPage (bookId: string, name: string): Promise<string> {
    let htmlPage = fetch(`${streamerBaseUrl}/streams/${bookId}/file/${name}`)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response.text()
      })

    return htmlPage
  },

  async fetchTableOfContent (accessToken: string, bookId: string): Promise<TableOfContent> {
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }
    try {
      return await (await fetch(`${baseUrl}/pubs/${bookId}/chapters`, options)).json()
    }
    catch (err) {
      return offlineHandler.getTableOfContent(bookId)
    }
  },

  searchInBook (bookId: string, term: string): Promise<Array<{}>> {
    let params = {
      'q': term,
      'order_by': 'page_number',
      'api_key': process.env.VUE_APP_API_KEY || ''
    }

    let query = Object.keys(params)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join('&')

    let pages = fetch(`${baseUrl}/search/${bookId}?${query}`)
      .then((response) => response.json())
      .then((data) => data)

    return pages
  }
}
